import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getWatchlistQueryOptions } from "./get-watchlist";
import { getWatchlistsQueryOptions } from "./get-watchlists";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export const addCarToWatchlist = async ({
  watchlistId,
  carId,
}: {
  watchlistId: string;
  carId: string;
}) => {
  return api.post(`/carburate/watchlists/${watchlistId}/cars/${carId}`) as Promise<void>;
};

type UseAddCarToWatchlistOptions = {
  mutationConfig?: MutationConfig<typeof addCarToWatchlist>;
};

export const useAddCarToWatchlist = ({ mutationConfig }: UseAddCarToWatchlistOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.refetchQueries({
        queryKey: getWatchlistQueryOptions({ watchlistId: variables.watchlistId }).queryKey,
      });
      queryClient.refetchQueries({
        queryKey: getWatchlistsQueryOptions().queryKey,
      });
      // Ensure the market car data is invalidated so UI (bell) updates immediately
      queryClient.invalidateQueries({
        queryKey: ["market", "cars", variables.carId],
      });
      onSuccess?.(data, variables, onMutateResult, context);
    },
    ...restConfig,
    mutationFn: addCarToWatchlist,
  });
};
